import dayjs from 'dayjs';
import {authHeader, isTokenExpired} from '../helpers';
import {format} from 'date-fns';

export const zoneScheduleService = {
  fetchAllSchedules,
  addSchedule,
  updateSchedule,
  addScheduleWithVideo,
  updateScheduleWithVideo,
  deleteSchedule,
  addScheduleToZones,
  addCampaignSchedule,
};

function fetchAllSchedules(frameId, target, index, from, to) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(`${process.env.REACT_APP_API_URL}/frames/${frameId}/zones/${target}/${index}/planification?from=${from}&to=${to}`, requestOptions)
    .then(res => isTokenExpired(res))
    .then(res => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function addCampaignSchedule(frameId, values) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(values)
  };

  return fetch(`${process.env.REACT_APP_API_URL}/frames/${frameId}/campaign-zone`, requestOptions)
    .then(res => isTokenExpired(res))
    .then(res => {
      if (res.status < 300) {
        return;
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function addSchedule(frameId, target, index, values) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(values)
  };

  return fetch(`${process.env.REACT_APP_API_URL}/frames/${frameId}/zones/${target}/${index}/planification`, requestOptions)
    .then(res => isTokenExpired(res))
    .then(res => {
      if (res.status === 201) {
        return;
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function updateSchedule(frameId, id, values) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: JSON.stringify(values)
  };

  return fetch(`${process.env.REACT_APP_API_URL}/frames/${frameId}/frame-zone-planification/${id}`, requestOptions)
    .then(res => isTokenExpired(res))
    .then(res => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function addScheduleWithVideo(frameId, target, index, values, video) {
  const form = new FormData();
  form.append('videoFile', video, video.name);
  form.append('beginDate', format(values.beginDate, 'yyyy-MM-dd HH:mm:ss.SSS'));
  form.append('endDate', format(values.endDate, 'yyyy-MM-dd HH:mm:ss.SSS'));
  form.append('planifTitle', values.planifTitle);
  form.append('planifDescription', values.planifDescription);
  form.append('title', values.title);
  form.append('description', values.description);
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(true),
    body: form
  };

  return fetch(`${process.env.REACT_APP_API_URL}/frames/${frameId}/zones/${target}/${index}/video`, requestOptions)
    .then(res => isTokenExpired(res))
    .then(res => {
      if (res.status === 201) {
        return;
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function updateScheduleWithVideo(frameId, id, values, video, zoneId) {
  const form = new FormData();
  form.append('videoFile', video, video.name);
  form.append('beginDate', format(values.beginDate, 'yyyy-MM-dd HH:mm:ss.SSS'));
  form.append('endDate', format(values.endDate, 'yyyy-MM-dd HH:mm:ss.SSS'));
  form.append('title', values.title);
  form.append('description', values.description);
  form.append('videoTitle', values.videoTitle);
  form.append('videoDescription', values.videoDescription);
  form.append('zoneId', zoneId);
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(true),
    body: form
  };

  return fetch(`${process.env.REACT_APP_API_URL}/frames/${frameId}/frame-zone-planification/${id}/video`, requestOptions)
    .then(res => isTokenExpired(res))
    .then(res => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function deleteSchedule(frameId, id) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader(),
  };

  return fetch(`${process.env.REACT_APP_API_URL}/frames/${frameId}/frame-zone-planification/${id}`, requestOptions)
    .then(res => isTokenExpired(res))
    .then(res => {
      if (res.status === 200) {
        return;
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function addScheduleToZones(state) {
  const form = new FormData();
  if (state.scheduleForm?.file) {
    form.append('media', state.scheduleForm.file, state.scheduleForm.file.name);
  } else {
    form.append('link', state.scheduleForm.http.concat(state.scheduleForm.targetUrl));
  }
  form.append('beginDate', dayjs(state.scheduleForm?.beginDate).format("YYYY-MM-DDTHH:mm:ssZ"));
  form.append('endDate', dayjs(state.scheduleForm?.endDate).format("YYYY-MM-DDTHH:mm:ssZ"));
  form.append('planifTitle', state.scheduleForm?.title);
  form.append('planifDescription', state.scheduleForm?.description);
  form.append('title', state.scheduleForm?.videoTitle);
  form.append('description', state.scheduleForm?.videoDescription);
  form.append('zones', JSON.stringify(state.zones));
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(true),
    body: form
  };

  const url = process.env.REACT_APP_API_URL + '/frames/zones/upload';

  return fetch(url, requestOptions)
    .then(res => isTokenExpired(res))
    .then(res => {
      if (res.status < 300) {
        return;
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}
